import React from 'react';
import PipelinelineSiteTable from '../PipelineSiteTable';

const Pipelines = () => <PipelinelineSiteTable />;

export default Pipelines;
